<template>
  <Layout>
    <div>
      <div class="me-container">
        <v-col class="text-left" md="4" sm="12">
          <span><b>รหัสสาขา : </b></span><span>{{ storeId }}</span>
        </v-col>
        <v-col class="text-left" md="4" sm="12">
          <span><b>ชื่อสาขา : </b></span><span>{{ storeName }}</span>
        </v-col>
        <v-col class="text-left" md="4" sm="12">
          <span><b>อัพเดทล่าสุด : </b></span>
          <span>{{ stockListUpdateAt }}</span>
        </v-col>
      </div>
      <div class="search-container">
        <div class="sku">
          <v-text-field v-model="sku" label="SKU"></v-text-field>
        </div>
        <div class="name">
          <v-text-field v-model="name" label="ชื่อ"></v-text-field>
        </div>
        <div class="action">
          <v-btn elevation="2" @click="fetchData" color="primary">
            ค้นหา
          </v-btn>
          <v-btn class="mx-2" elevation="2" @click="clear">
            ยกเลิก
          </v-btn>
        </div>
      </div>
    </div>
    <div>
      <template v-if="stockList">
        <TableStockLive
          :data="stockList"
          @select="cancelAutoUpdate"
        />
      </template>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/components/Layout'
import TableStockLive from '@/components/TableStockLive'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      stockList: (state) => state.stock.stockList,
      stockListUpdateAt: (state) => state.stock.stockListUpdateAt,
    }),

    storeId() {
      return this.me.org_unit.store_id
    },

    storeName() {
      return this.me.org_unit.store_name
    },

    timeLatest() {
      return this.me.org_unit.store_id
    },
  },

  components: {
    Layout,
    TableStockLive,
  },

  data() {
    return {
      timer: null,
      sku: '',
      name: '',
    }
  },

  created() {
    this.fetchData()
    this.timer = setInterval(this.fetchData, 10 * 60 * 1000)
  },

  methods: {
    async fetchData() {
      await this.$store.dispatch('stock/getStockList', {
        sku: this.sku,
        name: this.name,
        page: this.$route.query?.page,
      })

      this.$router.replace({
        ...this.$router.currentRoute,
        query: {
          sku: this.sku || undefined,
          name: this.name || undefined,
          page: this.$route.query?.page,
        },
      })
    },

    clear() {
      this.sku = ''
      this.name = ''
      this.fetchData()
    },

    cancelAutoUpdate() {
      clearInterval(this.timer)
    },
  },

  beforeUnmount() {
    this.cancelAutoUpdate()
  },
}
</script>

<style lang="stylus" scoped>

.me-container
  display: flex
  width: 100%
  align-items: flex-start
  margin : 0 -1rem
  @media tablet
    flex-wrap: wrap
    margin : 1rem 0
.search-container
  display: flex
  width: 100%
  align-items: center
  margin : 0 -1rem
  @media tablet
    flex-wrap: wrap
    margin : 1rem 0
  .sku
    width 35%
    margin: 0 1rem
    @media tablet
      width 100%
      margin: 0
  .name
    width 35%
    margin: 0 1rem
    @media tablet
      width 100%
      margin: 0
  .action
    width 30%
    margin: 0 1rem
    @media tablet
      width 100%
      margin: 0
</style>
